export type ChecklistAcaoKey = 'OK' | 'INSPECIONAR' | 'AJUSTAR' | 'TROCAR' | 'URGENTE';

export const CHECKLIST_ACOES: {
  key: ChecklistAcaoKey;
  label: string;
  color: string;
}[] = [
  { key: 'OK', label: 'OK', color: '#388E3C' },
  { key: 'INSPECIONAR', label: 'Inspecionar', color: '#FFA000' },
  { key: 'AJUSTAR', label: 'Ajustar', color: '#1976D2' },
  { key: 'TROCAR', label: 'Trocar', color: '#D32F2F' },
  { key: 'URGENTE', label: 'Urgente', color: '#7E57C2' },
];

export function defaultAcoesRecord(allOn = true): Record<ChecklistAcaoKey, boolean> {
  return CHECKLIST_ACOES.reduce(
    (acc, a) => {
      acc[a.key] = allOn;
      return acc;
    },
    {} as Record<ChecklistAcaoKey, boolean>
  );
}

export type ChecklistGrupoForm = {
  nome: string;
  itens: {
    titulo: string;
    obrigatoriaFoto: boolean;
    acoes: Record<ChecklistAcaoKey, boolean>;
  }[];
};

export function flattenGruposToItens(grupos: ChecklistGrupoForm[]) {
  const out: {
    ordem: number;
    grupo: string;
    categoria: string;
    titulo: string;
    obrigatoriaFoto: boolean;
    acoesPermitidas: ChecklistAcaoKey[];
  }[] = [];
  let ordem = 0;
  for (const g of grupos) {
    const grupo = g.nome.trim();
    if (!grupo) continue;
    for (const it of g.itens) {
      const titulo = it.titulo.trim();
      if (!titulo) continue;
      const acoesPermitidas = CHECKLIST_ACOES.map((a) => a.key).filter((k) => it.acoes[k]);
      if (!acoesPermitidas.length) continue;
      ordem += 1;
      out.push({
        ordem,
        grupo,
        categoria: grupo,
        titulo,
        obrigatoriaFoto: it.obrigatoriaFoto,
        acoesPermitidas,
      });
    }
  }
  return out;
}

export function itensApiToGrupos(
  itens: {
    grupo?: string;
    categoria?: string;
    titulo: string;
    obrigatoriaFoto?: boolean;
    acoesPermitidas?: string[];
  }[]
): ChecklistGrupoForm[] {
  const map = new Map<string, ChecklistGrupoForm>();
  for (const it of itens) {
    const nome = (it.grupo ?? it.categoria ?? '').trim() || 'Geral';
    if (!map.has(nome)) {
      map.set(nome, { nome, itens: [] });
    }
    const acoes = defaultAcoesRecord(false);
    const fromApi = it.acoesPermitidas ?? [];
    if (fromApi.length === 0) {
      Object.assign(acoes, defaultAcoesRecord(true));
    } else {
      for (const k of fromApi) {
        if (k in acoes) acoes[k as ChecklistAcaoKey] = true;
      }
    }
    map.get(nome)!.itens.push({
      titulo: it.titulo ?? '',
      obrigatoriaFoto: Boolean(it.obrigatoriaFoto),
      acoes,
    });
  }
  return Array.from(map.values());
}

export function emptyGrupo(): ChecklistGrupoForm {
  return {
    nome: '',
    itens: [{ titulo: '', obrigatoriaFoto: false, acoes: defaultAcoesRecord(true) }],
  };
}
